import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import {
  Grid,
  Card,
  Typography,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Avatar,
  IconButton,
  Skeleton,
  CircularProgress,
  InputAdornment,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getRole, getAclMenu } from '../../utils/common';
import { Helmet } from 'react-helmet-async';
import { useTheme, styled } from '@mui/material/styles';
import { SmartshileService } from './service';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { getToken } from '../../utils/common';
import { FloatButton, message, notification, Space} from 'antd';
import FolderIcon from '@mui/icons-material/Folder';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import RefreshIcon from '@mui/icons-material/Refresh';
import HelpIcon from '@mui/icons-material/Help';
import dayjs from 'dayjs';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import { makeStyles } from '@mui/styles';
import { title } from 'process';
import Autocomplete from '@mui/material/Autocomplete';
import TodayIcon from '@mui/icons-material/Today';
import { useLocation, useNavigate } from 'react-router-dom';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { checkValueTypeGlobal, capitalizeFirstLetterGlobal, determineTypeGlobal } from '../../components/helper';
import CircleIcon from '@mui/icons-material/Circle';
import CloseIcon from '@mui/icons-material/Close';
import { set, update } from 'lodash';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Row } from '@nextui-org/react';
import DialogPreview from '../../components/dialog/alert-detail/preview';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Document, Page, pdfjs } from 'react-pdf';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Nopreview from '../../../src/style/no-preview.png';
import LibraryMusicIcon from '@mui/icons-material/LibraryMusic';
import { node } from 'prop-types';

const url = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = url;

const useStyles = makeStyles({
  scrollable: {
    maxHeight: 500, // Anda dapat menyesuaikan tinggi maksimum sesuai kebutuhan
    overflowY: 'auto',
    width: 'inherit',
  },
  root: {
    '&:hover': {
      backgroundColor: 'yellow',
    },
  },
  icon: {
    marginRight: 5,
  },
});
//pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

export default function Dataset() {
  const history = useNavigate();
  const [parent, setParent] = useState([]);
  const [record, setRecord] = useState([]);
  const [recorddetail, setRecordDetail] = useState([]);
  const [orderlist, setOrderList] = useState([]);
  const [idAlreadyFetxh, setIdAlreadyFetch] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [focusedItemId, setFocusedItemId] = useState(null);
  const [tempdata, settempdata] = useState([]);
  const [isloadingrefresh, setisloadingrefresh] = useState(false);
  const [isdialogopen, setisdialogopen] = useState(false);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [resultcolor, setresultcolor] = useState([]);
  const [viewdata, setViewData] = useState(false);
  const [acl, setAcl] = useState(getAclMenu('data_set'));
  const [selectedData, setSelectedData] = useState('');
  const [lastfolderid, setLastFolderId] = useState('');
  const scrollableRef = useRef(null);
  const [limit, setLimit] = useState(1);

  const [filter, setFilter] = useState('');
  const [locklfilter, setLockFilter] = useState('');

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
    setIdAlreadyFetch([]);
    settempdata([]);
  };

  // const filteredData = useMemo(() => {
  //   if (!filter) return  fetchInfo(window.REACT_APP_API_PURE + 'datasetrecord', setParent);;
  //   const filterLower = filter.toLowerCase();

  //   const filterNodes = (nodes) => {
  //     return nodes
  //       .map((node) => {
  //         if (node.children) {
  //           const filteredChildren = filterNodes(node.children);
  //           if (filteredChildren.length > 0 || node.name.toLowerCase().includes(filterLower)) {
  //             return { ...node, children: filteredChildren };
  //           }
  //         } else if (node.name.toLowerCase().includes(filterLower)) {
  //           return node;
  //         }
  //         return null;
  //       })
  //       .filter(Boolean);
  //   };

  //   return filterNodes(parent);
  // }, [filter, parent]);

  const handleScroll = useCallback(
    () => {
      const element = scrollableRef.current;

      // console.log(element.scrollHeight - element.scrollTop === element.clientHeight - 0.25);
      if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
        inquiryAccountNumber(lastfolderid, limit + 1, { recreate: true });
        setLimit(limit + 1);
        // console.log('Reached the bottom');
        // fetchData(lastfolderid);
      }
    },
    [tempdata, settempdata] //[fetchData, lastfolderid]
  );

  useEffect(() => {
    const element = scrollableRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);

  const theme = useTheme();
  const [dialogUploadPreview, setDialogUploadPreview] = React.useState({
    open: false,
    base64String: '',
    type: '',
    handleClose: () => {
      setDialogUploadPreview((prevState) => ({ ...prevState, open: !prevState.open }));
    },
    path: '',
    filename: '',
  });
  const [stateTab2, setstateTab2] = useState({
    id: '',
    parentName: '',
    subParent: '',
    edges: [],
    changes: '',
    createdAt: '',
    action: '',
    schedule: '',
    repeatOn: 'Sunday',
    dailyTime: '',
    monthlyDate: '',
    monthlyTime: '',
    monthlyLastDate: '',
    monthlyLastTime: '',
    datadetail: '',
    namepath: '',
    action_id: '',
    totalfolder: 0,
    totalfile: 0,
  });
  const { getDataSet } = SmartshileService();
  const classes = useStyles();
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  };


  const fetchInfo = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.code === 401) {
          // setData('');
        } else {
          setdata(d);
        }
      });
  };
  const fetchInfo2 = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.code === 401) {
          // setData('');
        } else {
          setdata(d);
          setstateTab2((curr) => ({
            ...curr,
            changes: d.authorizedChanges + d.unAuthorizedChanges,
          }));
        }
      });
  };
  const fetchInfo3 = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        // console.log(d);
        if (d.code === 401 || d.code === 500) {
          // setData('');
        } else {
          setdata(d);
        }
      });
  };
  const fetchInfo6 = (url, setdata) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        if (d.code === 401 || d.code === 500) {
          // setData('');
        } else {
          if (d.after == undefined) {
            setdata(d);
            fetchImage(d);
          } else {
            setdata({
              data: d.after,
            });
            fetchImage({
              data: d.after,
            });
          }
        }
      });
  };
  const fetchImage = async (data) => {
    setImagePreviews([]);
    for (const key in data.data) {
      if (data.data.hasOwnProperty(key)) {
        const file = data.data[key];
        const filename = key;
        const path = file?.metaData?.storageMetaData?.path;
        // console.log('Filename:', filename);
        // console.log('Path:', path);
        if (path != undefined) {
          const handlePreview = async (fileUrl) => {
            try {
              const response = await fetch(fileUrl, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
              });

              if (!response.ok) {
                setImagePreviews((prevPreviews) => [
                  // ...prevPreviews,
                  { url: '', type: 'png', path: path, filename: filename },
                ]);
                console.error(`Error downloading file: ${response.statusText}`);
                return;
              }

              const contentType = response.headers.get('Content-Type');
              const blob = await response.blob();
              const url = URL.createObjectURL(blob);
              const parts = filename.split('.');

              // Get the last part (the file extension)
              const fileExtension = parts[parts.length - 1];
              // Add the URL to the previews array
              // console.log('fileExtension', fileExtension);
              setImagePreviews((prevPreviews) => [
                // ...prevPreviews,
                { url, type: 'png', path: path, filename: filename },
              ]);

              // Clean up
              // URL.revokeObjectURL(url);
            } catch (error) {
              setImagePreviews((prevPreviews) => [
                // ...prevPreviews,
                { url: '', type: 'png', path: path, filename: filename },
              ]);
              console.error('Error fetching file:', error);
            }
          };
          handlePreview(
            window.REACT_APP_API_PURE +
              `record/download/file/${encodeURIComponent(path.replace(/\//g, '%2F'))}/thumbnail`,
            filename
          );

          // try {
          //   const fileUrl = window.REACT_APP_API_PURE +`record/download/file/${path}`;
          //   const response = await fetch(fileUrl);
          //   const blob = await response.text();

          //   //  promises new Promise((resolve) => {
          //   //     const reader = new FileReader();
          //   //     reader.onloadend = () => {
          //   //       resolve(reader.result);
          //   //     };
          //   //     reader.readAsDataURL(blob);
          //   //   });
          //   //   const resolvedPreviews = await Promise.all(promises);

          // } catch (error) {
          //   console.error('Error fetching or reading files:', error);
          // }
        }
      }
    }
  };
  notification.config({
    placement: 'top',
  });
const [isNotificationActive, setIsNotificationActive] = useState(false);
  const addSchedule = (url, data2, info) => {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        title: findNodePath(parent, stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]),
        time_start:
          stateTab2.dailyTime == undefined || stateTab2.dailyTime == ''
            ? dayjs().format('YYYY-MM-DD hh:mm:ss A')
            : stateTab2.dailyTime,
        time_end:
          stateTab2.dailyTime == undefined || stateTab2.dailyTime == ''
            ? dayjs().format('YYYY-MM-DD hh:mm:ss A')
            : stateTab2.dailyTime,
        schedule: stateTab2.schedule == undefined || stateTab2.schedule == '' ? '' : stateTab2.schedule,
        repeat_on: '',
        dataset_id: selectedData?.type == 'folder' ? selectedData.id : '',
        record_id: selectedData?.type == 'file' ? selectedData.id : '',
        parent_name: stateTab2.parentName,
        // action_id: stateTab2.action_id,
      }),
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        // console.log(d);
        if (d.response_code === 500) {
          // setData('');
          notification.error({
            message: 'Error',
            description:  ('Gagal menambahkan jadwal'),  
            placement: 'top', 
            duration: 0, 
               // Bu
          })
        } else if (d.response_code === 200) {
          notification.success({
            message: 'Success',
            description: (t('VerificationPrompt.1')), // Title of the notification
            duration: 0, // Set duration to 0 for the notification to stay until clicked
             
            onClose: () => {
              // Update the state to enable the button when notification is closed
              setIsNotificationActive(false);
            },
          });
        } else if (d.error_message === 'There is no acction assosiate with this dataset please add action first') {
          notification.error({
            message: 'Error',
            description:  t('Please define an action for the dataset before requesting verification'),  
            placement: 'top', 
            duration: 0, 
               // Bu
          })
        } else {
          notification.error({
            message: 'Error',
            description:  t('There is error while processing the schedule, please contact Super Admin'),  
            placement: 'top', 
            duration: 0, 
               // Bu
          })
          // message.error(d.error_message);
        }
        // setstateTab2({
        //   schedule: undefined,
        //   dailyTime: undefined,
        // });
        if (info == '') {
          history('/dashboard/calendar');
        }
      });
  };

  useEffect(() => {
    fetchInfo(window.REACT_APP_API_PURE + 'datasetrecord', setParent);
    async function Fetchdataparent() {
      const response = await fetch(window.REACT_APP_API_PURE + 'datasetrecord', {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
      });
      const data = (await response.json()) || [];

      // Ensure data is an array before using map
      if (Array.isArray(data)) {
        data.map((item, row) => {
          if (resultcolor.filter((filterItem) => filterItem.id == item.id).length == 0) {
            setresultcolor((curr) => [...curr, item]);
          }
        });
      } else {
        console.error('Expected an array but received:', data);
      }
    }
    Fetchdataparent();
  }, []);

  const GenerateLabel = ({ tittle, value, variant = 'subtittle2' }) => {
    return (
      <Grid item xs={12} container direction={'row'}>
        <Grid item xs={6}>
          {' '}
          <Typography variant="subtittle2">{tittle}</Typography>
        </Grid>
        <Grid item xs={1}>
          {' '}
          <Typography variant="subtittle2">:</Typography>
        </Grid>
        <Grid item>
          <Typography variant={variant}>{value}</Typography>
        </Grid>
      </Grid>
    );
  };

  const inquiryAccountNumber = useCallback(async (id, limit, { recreate = false }) => {
    setIdAlreadyFetch((curr) => [...curr, id]);

    if (idAlreadyFetxh.includes(id) && !recreate) {
      return;
    }
    try {
      const res = await getDataSet(id, getToken(), limit);
      if (res.data.length > 0) {
        const newData = res.data.filter((item) => !tempdata.some((data) => data.id === item.id));
        settempdata((curr) => [...curr, ...newData.map((item) => ({ idparrent: id, ...item }))]);
      }
      if (res.data.length > 0) {
        const addChildToNode = (nodes, parentId) => {
          const newData = res.data.filter((item) => !tempdata.some((data) => data.id === item.id));
          return nodes?.map((node) => {
            if (node.id === parentId) {
              return {
                ...node,
                children: [...newData.map((item) => ({ idparrent: id, ...item }))],
              };
            } else if (node?.children && node?.children?.length > 0) {
              return {
                ...node,
                children: addChildToNode(node?.children, parentId),
              };
            } else {
              return node;
            }
          });
        };

        setParent((prevData) => addChildToNode(prevData, id));
      }
      return res.data;
    } catch (error) {
      console.log(error);
    }
  });

  const GenerateTime = () => {
    return (
      <Grid item xs={6} style={{ paddingTop: 8 }}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer
            components={['TimePicker']}
            sx={{
              minWidth: 0,
              // padding: 0,
              // height: 50,
              // margin: 0,
              overflow: 'hidden',
            }}
          >
            <TimePicker
              onChange={(newValue) => {
                // if (stateTab2.schedule == 'Daily') {
                // console.log(newValue.format('YYYY-MM-DD hh:mm:ss A'));
                // console.log(newValue);
                setstateTab2({ ...stateTab2, dailyTime: newValue.format('YYYY-MM-DD hh:mm:ss A') });
                // } else {
                //   const originalDateString = newValue.format('YYYY-MM-DD hh:mm:ss A');

                //   const timePart = originalDateString.split(' ')[1];

                //   const targetDateString = stateTab2.dailyTime;
                //   const newDateString = `${targetDateString.split(' ')[0]} ${timePart}`;

                //   // Parse the new date string using dayjs
                //   const dateObject = dayjs(newDateString);

                //   // Format the date as needed
                //   const formattedDate = dateObject.format('YYYY-MM-DD hh:mm:ss A');

                //   console.log(formattedDate);
                //   setstateTab2({ ...stateTab2, dailyTime: formattedDate });
                // }
              }}
              style={{ overflow: 'hidden' }}
              sx={{
                '& input': {
                  // height: 10,
                  marginTop: 0,
                  paddingTop: 1,
                  paddingBottom: 1,
                  minWidth: 0,
                },
                '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
                  minWidth: 0,
                  width: 150,

                  // padding: 10,
                },
                '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
                  minWidth: 0,
                },
              }}
              placeholder="Empty"
            />
          </DemoContainer>
        </LocalizationProvider>
      </Grid>
    );
  };

  const GenerateAdditional = () => {
    if (stateTab2.schedule == 'Weekly' || stateTab2.schedule == 'Monthly') {
      return (
        <Grid item container direction={'row'} xs={12} justifyContent={'space-around'}>
          <Grid item xs={3} alignSelf={'center'}>
            <Typography variant="subtittle2">{t('StartDate.1')}</Typography>
          </Grid>
          <Grid item xs={8}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']} sx={{ overflow: 'hidden' }}>
                <DatePicker
                  disablePast
                  ampm={false}
                  fullWidth
                  value={
                    stateTab2.dailyTime && dayjs(stateTab2.dailyTime).isValid() ? dayjs(stateTab2.dailyTime) : null
                  }
                  onChange={(newValue) => {
                    setstateTab2({ ...stateTab2, dailyTime: newValue.format('YYYY-MM-DD') });
                  }}
                  format="YYYY-MM-DD"
                  style={{ overflow: 'hidden' }}
                  sx={{
                    overflow: 'hidden',
                    '& input': {
                      // height: 10,
                      marginTop: 0,
                      paddingTop: 1,
                      paddingBottom: 1,
                      minWidth: 0,
                    },
                    '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
                      minWidth: 0,

                      // padding: 10,
                    },
                    '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
                      minWidth: 0,
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        </Grid>
      );
    }
    // else if (stateTab2.schedule == 'Monthly') {
    //   return (
    //     <Grid item container direction={'row'} xs={12}>
    //       <Grid item xs={12}>
    //         <Typography variant="subtittle2">First Day</Typography>
    //       </Grid>
    //       <Grid item xs={12} container direction={'row'}>
    //         <Grid item xs={6}>
    //           {' '}
    //           <LocalizationProvider dateAdapter={AdapterDayjs}>
    //             <DemoContainer components={['DatePicker']} sx={{ overflow: 'hidden' }}>
    //               <DatePicker
    //                 // label="Empty"
    //                 onChange={(event, newValue) => setstateTab2({ ...stateTab2, monthlyDate: newValue })}
    //                 style={{ overflow: 'hidden' }}
    //                 sx={{
    //                   overflow: 'hidden',
    //                   '& input': {
    //                     // height: 10,
    //                     marginTop: 0,
    //                     paddingTop: 1,
    //                     paddingBottom: 1,
    //                     minWidth: 0,
    //                   },
    //                   '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
    //                     minWidth: 0,
    //                     width: 160,

    //                     // padding: 10,
    //                   },
    //                   '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
    //                     minWidth: 0,
    //                   },
    //                 }}
    //               />
    //             </DemoContainer>
    //           </LocalizationProvider>
    //         </Grid>
    //         <Grid item xs={6}>
    //           <LocalizationProvider dateAdapter={AdapterDayjs}>
    //             <DemoContainer
    //               components={['TimePicker']}
    //               sx={{
    //                 overflow: 'hidden',
    //               }}
    //             >
    //               <TimePicker
    //                 onChange={(event, newValue) => setstateTab2({ ...stateTab2, monthlyTime: newValue })}
    //                 style={{ overflow: 'hidden' }}
    //                 sx={{
    //                   '& input': {
    //                     // height: 10,
    //                     marginTop: 0,
    //                     paddingTop: 1,
    //                     paddingBottom: 1,
    //                     minWidth: 0,
    //                   },
    //                   '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
    //                     minWidth: 0,
    //                     width: 150,

    //                     // padding: 10,
    //                   },
    //                   '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
    //                     minWidth: 0,
    //                   },
    //                 }}
    //                 placeholder="Empty"
    //               />
    //             </DemoContainer>
    //           </LocalizationProvider>
    //         </Grid>
    //       </Grid>
    //       <Grid item xs={12} style={{ paddingTop: 20 }}>
    //         <Typography variant="subtittle2">Last Day</Typography>
    //       </Grid>
    //       <Grid item xs={12} container direction={'row'}>
    //         <Grid item xs={6}>
    //           {' '}
    //           <LocalizationProvider dateAdapter={AdapterDayjs}>
    //             <DemoContainer components={['DatePicker']} sx={{ overflow: 'hidden' }}>
    //               <DatePicker
    //                 // label="Empty"
    //                 style={{ overflow: 'hidden' }}
    //                 sx={{
    //                   overflow: 'hidden',
    //                   '& input': {
    //                     // height: 10,
    //                     marginTop: 0,
    //                     paddingTop: 1,
    //                     paddingBottom: 1,
    //                     minWidth: 0,
    //                   },
    //                   '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
    //                     minWidth: 0,
    //                     width: 160,

    //                     // padding: 10,
    //                   },
    //                   '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
    //                     minWidth: 0,
    //                   },
    //                 }}
    //               />
    //             </DemoContainer>
    //           </LocalizationProvider>
    //         </Grid>
    //         <Grid item xs={6}>
    //           <LocalizationProvider dateAdapter={AdapterDayjs}>
    //             <DemoContainer
    //               components={['TimePicker']}
    //               sx={{
    //                 overflow: 'hidden',
    //               }}
    //             >
    //               <TimePicker
    //                 style={{ overflow: 'hidden' }}
    //                 sx={{
    //                   '& input': {
    //                     // height: 10,
    //                     marginTop: 0,
    //                     paddingTop: 1,
    //                     paddingBottom: 1,
    //                     minWidth: 0,
    //                   },
    //                   '& .css-ysycdn-MuiInputBase-root-MuiOutlinedInput-root ': {
    //                     minWidth: 0,
    //                     width: 150,

    //                     // padding: 10,
    //                   },
    //                   '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
    //                     minWidth: 0,
    //                   },
    //                 }}
    //                 placeholder="Empty"
    //               />
    //             </DemoContainer>
    //           </LocalizationProvider>
    //         </Grid>
    //       </Grid>
    //     </Grid>
    //   );
    // }
  };
  const handleFocus = (event, nodeId) => {
    setFocusedItemId(nodeId);
  };

  const handleBlur = (event, nodeId) => {
    setFocusedItemId(null);
  };

  const GenerateDialog = ({
    setDialogUploadPreview = setDialogUploadPreview,
    dialogUploadPreview = dialogUploadPreview,
    recorddetail = recorddetail,
    imagePreviewsinsides = imagePreviewsinsides,
    orderlistinside = orderlistinside,
    selectedindexinside = selectedindexinside,
    setselectedindexinside = setselectedindexinside,
  }) => {
    let _loading = false;
    const [selectedindexinside2, setselectedindexinside2] = useState(selectedindexinside);

    const [data, setData] = useState(recorddetail);
    const [imagePreviewsinside, setImagePreviewsinside] = useState(imagePreviewsinsides);

    const fetchInfoinside = (url, setdata) => {
      return fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
      })
        .then((res) => res.json())
        .then((d) => {
          if (d.code === 401 || d.code === 500) {
            // setData('');
          } else {
            if (d.after == undefined) {
              setdata(d);
              fetchImageInside(d);
            } else {
              setdata({
                data: d.after,
              });
              fetchImageInside({
                data: d.after,
              });
            }
          }
        });
    };
    const fetchImageInside = async (data) => {
      setImagePreviewsinside([]);
      for (const key in data.data) {
        if (data.data.hasOwnProperty(key)) {
          const file = data.data[key];
          const filename = key;
          const path = file?.metaData?.storageMetaData?.path;
          if (path != undefined) {
            const handlePreview = async (fileUrl) => {
              try {
                const response = await fetch(fileUrl, {
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
                });

                if (!response.ok) {
                  setImagePreviewsinside((prevPreviews) => [
                    // ...prevPreviews,
                    { url: '', type: 'png', path: path, filename: filename },
                  ]);
                  console.error(`Error downloading file: ${response.statusText}`);
                  return;
                }

                const contentType = response.headers.get('Content-Type');
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                const parts = filename.split('.');

                // Get the last part (the file extension)
                const fileExtension = parts[parts.length - 1];
                // Add the URL to the previews array
                // console.log('fileExtension', fileExtension);
                setImagePreviewsinside((prevPreviews) => [
                  // ...prevPreviews,
                  { url, type: 'png', path: path, filename: filename },
                ]);

                // Clean up
                // URL.revokeObjectURL(url);
              } catch (error) {
                setImagePreviewsinside((prevPreviews) => [
                  // ...prevPreviews,
                  { url: '', type: 'png', path: path, filename: filename },
                ]);
                console.error('Error fetching file:', error);
              }
            };
            handlePreview(
              window.REACT_APP_API_PURE +
                `record/download/file/${encodeURIComponent(path.replace(/\//g, '%2F'))}/thumbnail`,
              filename
            );
          }
        }
      }
    };
    function GenerateObject({ data = {} }) {
      // console.log(data);
      return Object.keys(data || {})?.map((key, index) => {
        const typevalue = checkValueTypeGlobal(data[key]);
        let tittle = capitalizeFirstLetterGlobal(key);
        let value = data[key];
        if (typevalue == 'string' || data[key] == null || typevalue == 'number') {
          value = data[key];
        } else {
          // tittle = '';
        }

        if (value == null) {
          if (
            key.includes('hash') ||
            key.includes('Hash') ||
            key.includes('HASH') ||
            key == 'bucketname' ||
            key == 'key' ||
            key == 'path' ||
            tittle == 'Bucket Name' ||
            tittle == 'Object Type' ||
            data[key] == 'ap-southeast-4' ||
            (tittle == 'Location' && data[key] == null)
          ) {
            return <span> </span>;
          }

          return (
            <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
              <Grid item>
                <Typography variant="body2">{tittle}</Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2">{value}</Typography>
              </Grid>
              <TextField
                variant="outlined"
                value={value}
                fullWidth
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                }}
              />
            </Grid>
          );
        }

        if (
          key.includes('hash') ||
          key.includes('Hash') ||
          key.includes('HASH') ||
          key == 'bucketname' ||
          key == 'key' ||
          key == 'path' ||
          tittle == 'BucketName' ||
          tittle == 'ObjectType' ||
          data[key] == 'ap-southeast-4' ||
          tittle == 'Location'
        ) {
          return <span> </span>;
        }
        return typevalue == 'object' ? (
          <Grid item container direction={'row'} spacing={2}>
            {determineTypeGlobal(value) == 'array' ? (
              <Grid item container direction={'row'} spacing={2}>
                <Grid item alignSelf={'center'}>
                  {' '}
                  <CircleIcon style={{ color: '#1EB3D9', fontSize: 10 }} />
                </Grid>
                <Grid item>
                  <Typography variant="h5">{capitalizeFirstLetterGlobal(key)}</Typography>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            {GenerateObject({ data: value })}
          </Grid>
        ) : (
          <Grid item xs={12} container direction={'row'} justifyContent={'space-between'}>
            <Grid item>
              <Typography variant="body2">{tittle}</Typography>
            </Grid>
            <TextField
              variant="outlined"
              value={value}
              fullWidth
              multiline
              InputProps={{
                readOnly: true,
                disableUnderline: true,
              }}
            />
          </Grid>
        );
      });
    }

    return (
      <Dialog
        minWidth={'lg'}
        open={isdialogopen}
        fullWidth
        onClose={() => {
          setisdialogopen(false);
        }}
        maxWidth={'lg'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogPreview
          open={dialogUploadPreview.open}
          handleClose={dialogUploadPreview.handleClose}
          // handleFileChange={handleFileChange}
          // handleUpload={handleUpload}
          data={dialogUploadPreview.base64String}
          path={dialogUploadPreview.path}
          type={dialogUploadPreview.type}
          filename={dialogUploadPreview.filename}
        />
        <DialogTitle id="alert-dialog-title">
          {stateTab2?.datadetail?.id}{' '}
          <IconButton
            aria-label="close"
            onClick={() => {
              setisdialogopen(false);
            }}
            sx={{ position: 'absolute', right: 8, top: 8, color: 'inherit' }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ overflowX: 'hidden' }}>
            <Grid container direction={'row'} spacing={2}>
              <Grid item xs={12}>
                <Typography variant={'h5'} style={{ color: 'black' }}>
                  {t('Historical.1')}
                </Typography>
              </Grid>
              <Grid item alignSelf={'center'}>
                <Avatar sx={{ width: 15, height: 15, backgroundColor: '#EE5020', fontSize: '10px' }}>
                  {record?.unAuthorizedChanges}
                </Avatar>
              </Grid>
              <Grid item>
                <Typography variant="caption">{t('UnauthorizedChanges.1')}</Typography>
              </Grid>
              <Grid item alignSelf={'center'}>
                <Avatar sx={{ width: 15, height: 15, backgroundColor: '#1EB3D9', fontSize: '10px', marginLeft: 3 }}>
                  {record?.authorizedChanges}
                </Avatar>
              </Grid>
              <Grid item>
                <Typography variant="caption"> {t('AuthorizedChanges.1')}</Typography>
              </Grid>
              <Grid item xs={12}>
                <div style={{ overflow: 'auto', marginTop: 10, marginBottom: 10, paddingLeft: 20 }}>
                  <Grid item xs={12} container direction={'row'} style={{ overflowX: 'auto', minWidth: 'max-content' }}>
                    {orderlistinside?.map((data, row) => {
                      return (
                        <div
                          onClick={() => {
                            setselectedindexinside2(row + 1);
                            _loading = true;
                            fetchInfoinside(
                              window.REACT_APP_API_PURE + `record/compare/${data.recordId}/${data.txInfos.txId}`,
                              setData
                            );
                            _loading = false;
                          }}
                        >
                          {MyComponent({
                            lengthinvalid: filterObject(data?.invalids || [], data?.updates || []).length,
                            lengthupdated: filterObject(data?.updates || [], data?.invalids || []).length,
                            valid: data.valid,
                            timeEpoch: data.epoch,
                            isEndList: orderlistinside?.length === row + 1,
                            highlight: (selectedindexinside2 || orderlistinside?.length) === row + 1,
                            index: row,
                          })}
                        </div>
                      );
                    })}
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={12} container direction={'row'}>
                <Grid item xs={12}>
                  {' '}
                  <Typography variant={'h5'} style={{ color: 'black' }}>
                    {t('RecordfromBlockchain.1')}
                  </Typography>
                </Grid>
                {_loading
                  ? 'Loading'
                  : imagePreviewsinside.map((preview, index) => (
                      <Grid item xs={4}>
                        <div key={index}>
                          {preview?.type === 'png' || preview?.type === 'jpg' ? (
                            <Card
                              raised
                              sx={{
                                maxWidth: 180,
                                margin: '0 auto',
                                padding: '0.1em',
                              }}
                            >
                              <CardMedia
                                component="img"
                                image={preview.url || Nopreview}
                                alt={`Preview ${index}`}
                                sx={{ padding: '1em 1em 0 1em', objectFit: 'contain' }}
                                onClick={() =>
                                  setDialogUploadPreview((prevState) => ({
                                    ...prevState,
                                    open: !prevState.open,
                                    base64String: preview.url,
                                    type: preview.type,
                                    path: preview.path,
                                    filename: preview.filename,
                                  }))
                                }
                              />
                              <CardContent style={{ textAlign: 'center' }}>
                                <Typography variant="caption">{preview.filename}</Typography>
                              </CardContent>

                              {preview.filename.includes('pdf') && (
                                <PictureAsPdfIcon
                                  fontSize="large"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    color: 'red', // Set the background color as needed
                                  }}
                                />
                              )}
                              {preview.filename.includes('mp3') && (
                                <LibraryMusicIcon
                                  fontSize="large"
                                  sx={{
                                    position: 'absolute',
                                    bottom: 0,
                                    right: 0,
                                    color: '#1EB3D9', // Set the background color as needed
                                  }}
                                />
                              )}
                            </Card>
                          ) : preview.type === 'pdf' ? (
                            <Document
                              file={preview.url}
                              onClick={() =>
                                setDialogUploadPreview((prevState) => ({
                                  ...prevState,
                                  open: !prevState.open,
                                  base64String: preview.url,
                                  type: preview.type,
                                  path: preview.path,
                                }))
                              }
                            >
                              <Page
                                pageNumber={1}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                width={300}
                                height={document.getElementsByClassName('PdfDiv')[0]?.clientHeight * 0.8 ?? 150}
                              />
                            </Document>
                          ) : (
                            <p>Unsupported file type</p>
                          )}
                        </div>
                      </Grid>
                    ))}
                {_loading ? 'Loading' : GenerateObject({ data: data.data })}
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  };

  function GenerateNewTree({ data, namaNode }) {
    return data?.length ? (
      data?.map((data2, row) => (
        <CustomTreeItem
          itemID={data2?.id}
          key={data2?.id}
          // focused={focusedItemId === data2?.id}
          // onFocus={(event) => handleFocus(event, data2?.id)}
          // onBlur={(event) => handleBlur(event, data2.id)}
          onClick={() => {
            // console.log('parent');
            // console.log(parent);
            if (data2?.type == 'folder') {
              inquiryAccountNumber(data2.id, 1, { recreate: false });
              setLastFolderId(data2.id);
              setLimit(1);
            } else {
              setViewData(true);
              fetchInfo6(window.REACT_APP_API_PURE + 'record/' + data2.id, setRecordDetail);
              fetchInfo3(window.REACT_APP_API_PURE + 'record/delta/' + data2.id, setOrderList);
            }
            handleFocus(null, data2.id);
            setSelectedData(data2);
            // console.log(data2);
            // console.log('awdakwmdawlll');
            setstateTab2({
              ...stateTab2,
              namepath: namaNode + ' > ' + data2.name,
              subParent: data2.name,
              lastType: data2?.type,
            });
            // console.log('akwdmadlwawd');
            // console.log(data2);
            // console.log(tempdata);
          }}
          label={
            <Grid container direction={'row'} spacing={1}>
              <Grid item>
                {data2?.type != 'folder' ? (
                  <InsertDriveFileIcon style={{ color: GenerateColor(data2) }} />
                ) : (
                  <FolderIcon style={{ color: GenerateColor(data2) }} />
                )}
              </Grid>
              <Grid item alignSelf={'end'}>
                <Typography variant="body2">{data2.name}</Typography>
              </Grid>
            </Grid>
          }
        >
          {/* {JSON.stringify(tempdata?.filter((item) => item?.data?.parentId == data2.id))} */}
          {data2?.data?.recordCount > 0
            ? GenerateNewTree({
                // data: tempdata?.filter((item) => item?.idparrent == data2.id),
                data: data2?.children,
                namaNode: namaNode + data2.name,
              })
            : ''}
        </CustomTreeItem>
      ))
    ) : data?.some((item) => item?.type != 'folder') ? (
      <CircularProgress />
    ) : (
      <span />
    );
  }
  function GenerateNewTreeFile({ data, namaNode }) {
    return data?.length ? (
      data?.map((data2, row) => (
        <CustomTreeItem
          itemID={data2?.id}
          key={data2?.id}
          focused={focusedItemId === data2?.id}
          onFocus={(event) => handleFocus(event, data2?.id)}
          // onBlur={(event) => handleBlur(event, data2.id)}
          onClick={() => {
            if (data2?.type == 'folder') {
              inquiryAccountNumber(data2.id, 1, { recreate: false });
              setLastFolderId(data2.id);
              setLimit(1);
              setstateTab2({
                ...stateTab2,
                namepath: namaNode + ' > ' + data2.name,
                subParent: data2.name,
                data: data2,
                lastType: data2?.type,
              });
            } else {
              setViewData(true);
              fetchInfo6(window.REACT_APP_API_PURE + 'record/' + data2.id, setRecordDetail);
              fetchInfo3(window.REACT_APP_API_PURE + 'record/delta/' + data2.id, setOrderList);
              let name = namaNode + ' > ' + data2.name;
              if (stateTab2.lastType != 'folder') {
                name = stateTab2.namepath.split(' > ').slice(0, -1).join(' > ') + ' > ' + data2.name;
              }
              setstateTab2({
                ...stateTab2,
                namepath: name,
                subParent: data2.name,
                data: data2,
                lastType: data2?.type,
              });
            }
            handleFocus(null, data2.id);
            setSelectedData(data2);
            // console.log(data2);
            // console.log('awdakwmdawlll');
          }}
          label={
            <Grid container direction={'row'} spacing={1}>
              <Grid item>
                {data2?.type != 'folder' ? (
                  <InsertDriveFileIcon style={{ color: GenerateColor(data2) }} />
                ) : (
                  <FolderIcon style={{ color: GenerateColor(data2) }} />
                )}
              </Grid>
              <Grid item alignSelf={'end'}>
                <Typography variant="body2">{data2.name}</Typography>
              </Grid>
            </Grid>
          }
        >
          {data2?.data?.recordCount > 0
            ? GenerateNewTreeFile({
                data: tempdata?.filter((item) => item?.data?.parentId === data2.id),
                namaNode: namaNode + data2.name,
              })
            : ''}
        </CustomTreeItem>
      ))
    ) : data?.some((item) => item?.type != 'folder') ? (
      <CircularProgress />
    ) : (
      <span />
    );
  }

  const GenerateColor = (data) => {
    if (data?.openAlertCount > 0) {
      return theme.palette.error.main;
    } else if (data?.inProgressAlertCount > 0) {
      return theme.palette.warning.main;
    } else if (data?.pendingApprovalAlertCount > 0) {
      return theme.palette.info.main;
    } else if (data?.pendingRollbackAlertCount > 0) {
      return theme.palette.primary.main;
    } else {
      return 'green';
    }
  };
  const { t } = useTranslation();

  const findNodePath = (nodes, targetName, path = []) => {
    for (let node of nodes) {
      const currentPath = [...path, node.name];
      if (node.name === targetName) {
        return currentPath.join(' > ');
      }
      if (node.children && node.children.length > 0) {
        const result = findNodePath(node.children, targetName, currentPath);
        if (result) {
          return result;
        }
      }
    }
    return null;
  };
  const renderTree = (nodes, first, namaNode) =>
    nodes?.type == 'file' && !first ? (
      ''
    ) : (
      <TreeItem
        key={nodes?.id}
        nodeId={nodes?.id}
        label={
          <Grid container direction={'row'} spacing={1}>
            <Grid item>
              {nodes?.type != 'folder' ? (
                <InsertDriveFileIcon style={{ color: GenerateColor(nodes) }} />
              ) : (
                <FolderIcon style={{ color: GenerateColor(nodes) }} />
              )}
            </Grid>
            <Grid item alignSelf={'end'}>
              <Typography variant="body2">{nodes?.name}</Typography>
            </Grid>
          </Grid>
        }
        onClick={() => {
          if (first) {
            inquiryAccountNumber(nodes?.id, 1, { recreate: false });
            handleFocus(null, nodes?.id);
            setSelectedData(nodes);
            setstateTab2({
              ...stateTab2,
              namepath: nodes?.name,
              parentName: nodes?.name,
              subParent: nodes?.name,
              data: nodes,
              lastType: nodes?.type,
            });
            if (nodes?.type == 'folder') {
              // console.log('folder');
              // console.log(nodes);
              setLastFolderId(nodes?.id);
              setLimit(1);
            } else {
              setViewData(true);
              fetchInfo6(window.REACT_APP_API_PURE + 'record/' + nodes?.id, setRecordDetail);
              fetchInfo3(window.REACT_APP_API_PURE + 'record/delta/' + nodes?.id, setOrderList);
              let name = namaNode + ' > ' + nodes?.name;
              if (stateTab2.lastType != 'folder') {
                name = stateTab2.namepath.split(' > ').slice(0, -1).join(' > ') + ' > ' + nodes?.name;
              }
              setstateTab2({
                ...stateTab2,
                namepath: name,
                subParent: nodes?.name,
                data: nodes,
                lastType: nodes?.type,
              });
              handleFocus(null, nodes?.id);
              setSelectedData(nodes);
            }
          } else {
            if (nodes?.type == 'folder') {
              // console.log('kesini2');
              inquiryAccountNumber(nodes?.id, 1, { recreate: false });
              setLastFolderId(nodes?.id);
              setLimit(1);
            } else {
              setViewData(true);
              fetchInfo6(window.REACT_APP_API_PURE + 'record/' + nodes?.id, setRecordDetail);
              fetchInfo3(window.REACT_APP_API_PURE + 'record/delta/' + nodes?.id, setOrderList);
            }
            handleFocus(null, nodes?.id);
            setSelectedData(nodes);
            setstateTab2({
              ...stateTab2,
              namepath: stateTab2.namepath + ' > ' + nodes?.name,
              subParent: nodes?.name,
              data: nodes,
              lastType: nodes?.type,
            });
          }
        }}
      >
        {Array.isArray(nodes?.children) ? (
          nodes?.children.map((node) => renderTree(node, false, nodes?.name))
        ) : nodes?.data?.recordCount > 0 ? (
          <span />
        ) : null}
      </TreeItem>
    );

  const CustomTreeItem = styled(TreeItem)(({ theme, focused }) => ({
    ...(focused && {
      backgroundColor: theme.palette.action.selected,
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    }),
  }));

  const [isLoading, setIsLoading] = useState(false);
  return (
    <span>
      <Helmet>
        <title>Dataset Map | SmartShield</title>
      </Helmet>
      <Card style={{ marginTop: 20, minHeight: '80vh', maxHeight: '80vh', overflow: 'auto' }}>
        <Grid container direction={'row'}>
          <GenerateDialog
            recorddetail={recorddetail}
            setDialogUploadPreview={setDialogUploadPreview}
            dialogUploadPreview={dialogUploadPreview}
            imagePreviewsinsides={imagePreviews}
            orderlistinside={orderlist}
            selectedindexinside={selectedIndex}
            setselectedindexinside={setSelectedIndex}
          />
          <Grid item xs={12} style={{ borderBottom: '1px solid #D1D1D1' }}>
            <Typography variant="h5" style={{ color: 'grey', padding: 20 }}>
              Dataset{' '}
              {findNodePath(parent, stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1])}
            </Typography>
          </Grid>
          <Grid item xs={4} style={{ borderRight: '1px solid #D1D1D1', padding: 10 }} container direction={'row'}>
            <div style={{ minWidth: '-webkit-fill-available' }}>
              <Grid container direction={'row'}>
                <Grid
                  item
                  style={{ paddingTop: 20, paddingLeft: 20 }}
                  xs={12}
                  container
                  direction={'row'}
                  alignItems={'center'}
                >
                  <Grid item container direction={'row'} xs={12} justifyContent={'space-between'}>
                    <Grid item>
                      <Typography variant="h5">Datasets</Typography>
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Search"
                        variant="outlined"
                        value={filter}
                        size="small"
                        onChange={handleFilterChange}
                        style={{ marginBottom: '20px' }}
                        onKeyDown={(event) => {
                          if (event.key === 'Enter') {
                            fetchInfo(window.REACT_APP_API_PURE + 'datasetrecord?q=' + filter, setParent);
                            setLockFilter(filter);
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              {locklfilter == filter && filter != '' ? (
                                <IconButton
                                  onClick={() => {
                                    setisloadingrefresh(true);
                                    setIdAlreadyFetch([]);
                                    settempdata([]);
                                    setParent([]);
                                    setFilter('');
                                    fetchInfo(window.REACT_APP_API_PURE + 'datasetrecord', setParent);
                                    setisloadingrefresh(false);
                                  }}
                                >
                                  <RefreshIcon />
                                </IconButton>
                              ) : (
                                <IconButton
                                  onClick={() => {
                                    fetchInfo(window.REACT_APP_API_PURE + 'datasetrecord?q=' + filter, setParent);
                                    setLockFilter(filter);
                                  }}
                                >
                                  <SearchIcon />
                                </IconButton>
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{ paddingLeft: 20, paddingTop: 20 }}>
                  {isloadingrefresh ? (
                    <CircularProgress />
                  ) : (
                    <TreeView defaultCollapseIcon={<ExpandMoreIcon />} defaultExpandIcon={<ChevronRightIcon />}>
                      {parent.map((node) => renderTree(node, true, node.name))}
                    </TreeView>
                  )}
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={4} style={{ borderRight: '1px solid #D1D1D1' }} container direction={'row'}>
            <Grid item xs={12}>
              {selectedData == '' ? (
                ''
              ) : (
                <div style={{ paddingTop: 20 }}>
                  <Grid container direction={'row'} spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="h5" style={{ paddingLeft: 10 }}>
                        Records
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography style={{ padding: 15, backgroundColor: '#F1FAFE' }} variant="h6">
                        {findNodePath(
                          parent,
                          stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                        ) === ''
                          ? ''
                          : findNodePath(
                              parent,
                              stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                            )?.includes(' > ')
                          ? findNodePath(
                              parent,
                              stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                            )?.split(' > ')[0]
                          : findNodePath(
                              parent,
                              stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                            )?.trim() || ''}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography style={{ padding: 20, borderBottom: '1px solid #E7E7E7' }}>
                        <FolderIcon
                          style={{
                            color: GenerateColor(stateTab2.data),
                          }}
                        />{' '}
                        {stateTab2.subParent}
                      </Typography>
                    </Grid>
                    <Grid item className={classes.scrollable} ref={scrollableRef}>
                      {GenerateNewTreeFile({
                        data: tempdata?.filter((item) => item.idparrent == lastfolderid),
                        namaNode: stateTab2.namepath,
                        records: true,
                      })}
                    </Grid>
                    {tempdata?.filter((item) => item.idparrent == selectedData.id).length != 0 ? (
                      ''
                    ) : (
                      <Grid item xs={12} style={{ marginTop: 0 }} container direction={'row'}>
                        {stateTab2?.edges?.map((data, row) => {
                          return (
                            <Grid item xs={12}>
                              <Button
                                variant="text"
                                startIcon={<InsertDriveFileIcon style={{ color: '#1EB3D9' }} />}
                                onClick={() => {
                                  // console.log(data);
                                  setImagePreviews([]);
                                  setViewData(true);

                                  if (Number.isInteger(data.id)) {
                                    fetchInfo2(window.REACT_APP_API_PURE + 'dataset/changes/' + data.id, setRecord);
                                  } else {
                                    fetchInfo2(window.REACT_APP_API_PURE + 'record/changes/' + data.id, setRecord);
                                  }
                                  fetchInfo6(window.REACT_APP_API_PURE + 'record/' + data.id, setRecordDetail);
                                  fetchInfo3(window.REACT_APP_API_PURE + 'record/delta/' + data.id, setOrderList);

                                  if (stateTab2.namepath.includes(data.id)) {
                                  } else {
                                    const fixedpath = stateTab2.namepath.split(' > ').slice(0, -1).join(' > ');
                                    const lastPath = stateTab2.namepath.split(' > ').pop();

                                    if (lastPath.length > 23 || !lastPath.includes(' ')) {
                                      if (data.id.length > 23 || !data.id.includes(' ')) {
                                        setstateTab2({
                                          ...stateTab2,
                                          datadetail: data,
                                          namepath:
                                            fixedpath == ''
                                              ? stateTab2.namepath + ' > ' + data.id
                                              : fixedpath + ' > ' + data.id,
                                          parentName: data.id,
                                          totalfile: 1,
                                          totalfolder: 0,
                                        });
                                      } else {
                                        setstateTab2({
                                          ...stateTab2,
                                          datadetail: data,
                                          namepath: stateTab2.namepath + ' > ' + data.id,
                                          parentName: data.id,
                                          totalfile: 1,
                                          totalfolder: 0,
                                        });
                                      }
                                    } else {
                                      if (data.id.length > 23 || !data.id.includes(' ')) {
                                        setstateTab2({
                                          ...stateTab2,
                                          datadetail: data,
                                          namepath: stateTab2.namepath + ' > ' + data.id,
                                          parentName: data.id,
                                          totalfile: 1,
                                          totalfolder: 0,
                                        });
                                      } else {
                                        setstateTab2({
                                          ...stateTab2,
                                          datadetail: data,
                                          namepath: stateTab2.namepath + ' > ' + data.id,
                                          parentName: data.id,
                                          totalfile: 1,
                                          totalfolder: 0,
                                        });
                                      }
                                    }
                                  }
                                }}
                              >
                                {data.id}
                              </Button>
                            </Grid>
                          );
                        })}
                      </Grid>
                    )}
                  </Grid>
                </div>
              )}
            </Grid>
          </Grid>
          <Grid item xs={4}>
            {selectedData == '' ? (
              ''
            ) : (
              <div style={{ padding: 20 }}>
                <Grid container direction={'row'} spacing={2}>
                  <Grid item xs={12} container direction={'row'} spacing={2}>
                    <Grid item>
                      {' '}
                      <Typography variant="h5">{t('Detail.1')}</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} style={{ borderBottom: '1px solid #D1D1D1' }}></Grid>
                  <Grid item xs={12} container direction={'row'} style={{ marginLeft: 30, marginTop: 10 }}>
                    {GenerateLabel({
                      tittle: t('Name.1'),
                      value: stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1],
                    })}
                    {GenerateLabel({
                      tittle: t('Parent.1'),
                      value:
                        findNodePath(
                          parent,
                          stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                        ) === ''
                          ? ''
                          : findNodePath(
                              parent,
                              stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                            )?.includes(' > ')
                          ? findNodePath(
                              parent,
                              stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                            )?.split(' > ')[
                              findNodePath(
                                parent,
                                stateTab2.namepath?.split(' > ')[stateTab2.namepath?.split(' > ').length - 1]
                              )?.split(' > ').length - 2
                            ]
                          : '',
                    })}
                    {GenerateLabel({
                      tittle: t('Contains.1'),
                      value: (selectedData?.data?.recordCount || 0) + ' Records',
                      // selectedData?.type == 'folder'
                      //   ? (selectedData.data.recordCount || 0) + ' Records'
                      //   : (selectedData.data.recordCount || 0) + ' Folders',
                    })}
                  </Grid>
                  <Grid item xs={12} style={{ borderBottom: '1px solid #D1D1D1' }}></Grid>
                  <Grid item xs={12} container direction={'row'} style={{ marginLeft: 30, marginTop: 10 }}>
                    {GenerateLabel({
                      tittle: t('Changes.1'),
                      value: (selectedData?.authorizedCount || 0) + (selectedData?.unAuthorizedCount || 0),
                    })}
                  </Grid>
                  <Grid item xs={12} style={{ textAlignLast: 'right' }}>
                    <Typography variant="subtittle2" style={{ color: '#49C9EA', backgroundColor: '#F1FAFE' }}>
                      {selectedData?.authorizedCount || 0} {t('AuthorizedChanges.1')}
                    </Typography>
                    <div />
                    <Typography variant="subtittle2" style={{ color: '#F57A74', backgroundColor: '#FEF3F2' }}>
                      {selectedData?.unAuthorizedCount || 0} {t('UnauthorizedChanges.1')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} textAlign={'right'}>
                    <Button
                      variant="outline"
                      disabled={!viewdata}
                      style={{ backgroundColor: !viewdata ? 'gray' : '#12A2CE', color: 'white' }}
                      onClick={() => {
                        setSelectedIndex(null);
                        setisdialogopen(true);
                        // console.log(orderlist);
                        fetchInfo6(
                          window.REACT_APP_API_PURE +
                            `record/compare/${orderlist[orderlist.length - 1].recordId}/${
                              orderlist[orderlist.length - 1].txInfos.txId
                            }`,
                          setRecordDetail
                        );
                        // // fetchInfo6(window.REACT_APP_API_PURE + 'record/' + idOrder.id, setRecordDetail);
                        // fetchInfo3(window.REACT_APP_API_PURE + 'record/delta/' + idOrder.id, setOrderList);
                      }}
                    >
                      {t('View.1')}
                    </Button>
                  </Grid>
                  <Grid item xs={12} container direction={'row'} style={{ marginLeft: 30, marginTop: 10 }}>
                    {GenerateLabel({ tittle: t('LatestUpdate.1'), value: stateTab2.createdAt, variant: 'caption' })}
                  </Grid>
                  <Grid item xs={12} style={{ borderBottom: '1px solid #D1D1D1' }}></Grid>
                  {!acl.verify ? (
                    ''
                  ) : (
                    <Grid item xs={12} container direction={'row'}>
                      <Grid item container direction={'row'} xs={12} justifyContent={'space-between'}>
                        <Grid item>
                          <Typography variant="caption">
                            {new Date().toLocaleDateString('en-US', {
                              weekday: 'long',
                              month: 'long',
                              day: 'numeric',
                              year: 'numeric',
                            })}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid item style={{ marginTop: 20 }}>
                        <TodayIcon style={{ color: '#12A2CE' }} />
                      </Grid>
                      <Grid item style={{ marginTop: 20 }}>
                        <Typography variant="subtittle2">{t('VerifSchedule.1')}</Typography>
                      </Grid>
                      <Grid item xxs={12} container direction={'row'} spacing={2}>
                        <Grid item xs={6}>
                          <Autocomplete
                            fullWidth
                            size="small"
                            id={`combo-box-demo-}`} // Unique ID for each Autocomplete
                            options={[{ label: 'Daily' }, { label: 'Weekly' }, { label: 'Monthly' }]}
                            placeholder={t('Empty.1')}
                            value={[{ label: 'Daily' }, { label: 'Weekly' }, { label: 'Monthly' }].find(
                              (e) => e.label === stateTab2.schedule
                            )}
                            onChange={(event, newValue, reason) => {
                              if (reason == 'clear') {
                                setstateTab2({ ...stateTab2, schedule: '' });
                              } else {
                                setstateTab2({ ...stateTab2, schedule: newValue.label });
                              }
                            }}
                            renderInput={(params) => <TextField {...params} placeholder={'Empty'} />}
                          />
                        </Grid>
                        {GenerateTime()}
                        {GenerateAdditional()}
                      </Grid>

                      <Grid item xs={12} style={{ marginBottom: 20 }}>
                        <Button
                          // title: stateTab2.parentName,
                          // time_start: stateTab2.dailyTime,
                          // time_end: stateTab2.dailyTime,
                          // schedule: stateTab2.schedule,
                          disabled={
                            stateTab2.schedule == undefined ||
                            stateTab2.schedule == '' ||
                            stateTab2.dailyTime == undefined ||
                            stateTab2.dailyTime == '' ||
                            !dayjs(stateTab2.dailyTime).isValid() ||
                            isNotificationActive
                          }
                          fullWidth
                          style={{
                            backgroundColor:
                              stateTab2.schedule == undefined ||
                              stateTab2.schedule == '' ||
                              stateTab2.dailyTime == undefined ||
                              stateTab2.dailyTime == '' ||
                              !dayjs(stateTab2.dailyTime).isValid() ||
                              isNotificationActive
                                ? 'gray'
                                : '#12A2CE',

                            color: 'white',
                            marginTop: 50,
                          }}
                          onClick={() => {
                            setIsNotificationActive(true);
                            addSchedule(window.REACT_APP_API_PURE + 'calendar/addcalendar', '');
                          }}
                        >
                          {t('VerifSchedule.2')}
                        </Button>
                        {/* )} */}
                      </Grid>
                      <Grid item xs={12} style={{ borderBottom: '1px solid #D1D1D1' }}></Grid>

                      <Grid item xs={12}>
                        {/* {getRole() == 'Maker' ? (
                      ''
                    ) : ( */}
                        <Button
                          disabled={isNotificationActive}
                          fullWidth
                          style={{
                            backgroundColor:
                              isNotificationActive
                                ? 'gray'
                                : '#12A2CE',

                            color: 'white',
                          }}
                          onClick={() => {
                            setIsNotificationActive(true);
                            if (stateTab2.schedule == undefined) {
                              setstateTab2({
                                ...stateTab2,
                                // action: action.data[0].action_name,
                                schedule: 'Daily',
                                dailyTime: dayjs().format('YYYY-MM-DD '),
                              });
                            }
                            addSchedule(window.REACT_APP_API_PURE + 'calendar/addcalendar', 'now');
                            setTimeout(() => {
                              setIsLoading(false);
                            }, 4000);
                            // alert('Berhasil menambahkan jadwal');
                            // history('/dashboard/calendar');
                          }}
                        >
                          {t('VerifSchedule.3')}
                        </Button>
                        {/* )} */}
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </div>
            )}
          </Grid>
        </Grid>
      </Card>
    </span>
  );
}

function MyComponent({
  lengthinvalid = 0,
  lengthupdated = 0,
  valid = false,
  timeEpoch,
  isEndList = false,
  highlight,
  index,
}) {
  const date = new Date(timeEpoch);
  const options = { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'Asia/Jakarta' };
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  const hours = date.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = (hours % 12 || 12).toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  const formattedTime = `${formattedHours}:${minutes} ${ampm}`;
  return (
    <>
      <div className="div" style={{ borderBottom: highlight ? '2px solid #0048f9f2' : '' }}>
        <div className="div-2">
          <div className="div-3">
            <div className="div-4">
              {lengthupdated > 0 && valid == false ? (
                <span>
                  <img loading="lazy" src={'/assets/X.png'} alt="line Logo" className="img" />
                  <img loading="lazy" src={'/assets/close.png'} alt="line Logo" className="img" />
                </span>
              ) : lengthupdated == 0 && valid == false ? (
                <img loading="lazy" src={'/assets/close.png'} alt="line Logo" className="img" />
              ) : (
                <img loading="lazy" src={'/assets/X.png'} alt="line Logo" className="img" />
              )}
            </div>
            {isEndList ? '' : <div className="div-5" />}
          </div>
          <div className="div-6">
            <img src="/assets/Line.png" alt="line Logo" className="w-100" />
            <div className="div-7">
              <div className="div-8">{formattedDate}</div>
              <div className="div-9">{formattedTime}</div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .div {
          display: flex;
          gap: 4px;
        }
        .div-2 {
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-3 {
          display: flex;
          justify-content: space-between;
          gap: 4px;
        }
        .div-4 {
          justify-content: center;
          align-items: center;
          border-radius: 131.413px;
          border: 1.027px solid var(--Stroke-Light-Base, #e5e5e7);
          box-shadow: 0px 1.027px 2.053px 0px rgba(16, 24, 40, 0.04);
          background-color: var(--Background-Light-Base-Main, #fff);
          display: flex;
          aspect-ratio: 1;
          flex-direction: column;
          width: 44px;
          height: 44px;
          padding: 0 12px;
        }
        .img {
          aspect-ratio: 0.95;
          object-fit: contain;
          object-position: center;
          width: 100%;
          overflow: hidden;
        }
        .div-5 {
          background-color: #bfeaf8;
          align-self: center;
          width: 55px;
          height: 1px;
          margin: auto 0;
        }
        .div-6 {
          align-items: start;
          display: flex;
          margin-top: 4px;
          justify-content: space-between;
          gap: 8px;
          padding: 0 19px;
        }
        .img-2 {
          aspect-ratio: 0.07;
          object-fit: contain;
          object-position: center;
          width: 1px;
          stroke-width: 1px;
          stroke: var(--Blue-300, #86dcf3);
          overflow: hidden;
          max-width: 100%;
        }
        .div-7 {
          align-self: stretch;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-8 {
          color: var(--Blue-700, #0e7496);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
        .div-9 {
          color: var(--Blue-700, #0e7496);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
        .div-10 {
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-11 {
          display: flex;
          justify-content: space-between;
          gap: 4px;
        }
        .div-12 {
          justify-content: center;
          align-items: center;
          border-radius: 131.413px;
          border: 1.027px solid var(--Stroke-Light-Base, #e5e5e7);
          box-shadow: 0px 1.027px 2.053px 0px rgba(16, 24, 40, 0.04);
          background-color: var(--Background-Light-Base-Main, #fff);
          display: flex;
          aspect-ratio: 1;
          flex-direction: column;
          width: 44px;
          height: 44px;
          padding: 0 12px;
        }
        .div-13 {
          background-color: #bfeaf8;
          align-self: center;
          width: 55px;
          height: 1px;
          margin: auto 0;
        }
        .div-14 {
          align-items: start;
          display: flex;
          margin-top: 4px;
          justify-content: space-between;
          gap: 8px;
          padding: 0 19px;
        }
        .img-3 {
          aspect-ratio: 0.07;
          object-fit: contain;
          object-position: center;
          width: 1px;
          stroke-width: 1px;
          stroke: var(--Red-400, #ff5b6c);
          overflow: hidden;
          max-width: 100%;
        }
        .div-15 {
          align-self: stretch;
          display: flex;
          flex-grow: 1;
          flex-basis: 0%;
          flex-direction: column;
        }
        .div-16 {
          color: var(--Red-600, #f90921);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
        .div-17 {
          color: var(--Red-600, #f90921);
          white-space: nowrap;
          font: 500 11px/127% Roboto, -apple-system, Roboto, Helvetica, sans-serif;
        }
      `}</style>
    </>
  );
}

const filterObject = (arr1, arr2) => {
  const pathsToRemove = new Set(arr2.map((obj) => obj.path));
  return arr1.filter((obj) => !pathsToRemove.has(obj.path));
};
